import { DateTime } from 'luxon';
import React, { useCallback, useState } from 'react';
import './TelemetryCard.scss';
import Icons, { Size } from 'components/Common/Icons';
import PropTypes from 'prop-types';
import { Button, ButtonVariant, Tooltip, Card, CardBody, CardFooter, CardHeader, CardTitle } from '@patternfly/react-core';
import ChartViewModal from 'components/Chart/ChartViewModal';
import { Aggregation } from 'services/constants';
import Value from 'components/Value/Value';
import TimeStamp from 'components/Time/TimeStamp';
import { fontWeights, fontSizes, fontStyles } from 'utils/font';

// eslint-disable-next-line no-unused-vars
const TelemetryCardV2 = ({ telemetrySchema, telemetryValue, assetId, hideUnit = false, hideChart = false, isSelectable = true }) => {

  const [viewSignal, setViewSignal] = useState(null);
  // const [selected, setSelected] = useState([]);

  const onCloseChartView = useCallback(() => {
    setViewSignal(null);
  }, []);

  const showChartView = useCallback(() => {
    setViewSignal({
      assetId,
      signals: [{
        fullName: telemetrySchema.displayName,
        name: telemetrySchema.name,
        component: telemetrySchema.componentName,
        type: telemetrySchema.schema,
        aggregate: Aggregation.MEAN
      }]
    });
  }, [assetId, telemetrySchema.componentName, telemetrySchema.displayName, telemetrySchema.name, telemetrySchema.schema]);

  const headerActions =
    (<>
      { !hideChart && <Button onClick={showChartView} variant={ButtonVariant.plain}><Icons.ChartLine size={Size.LARGE}/></Button> }
      { telemetrySchema.description &&
              <Tooltip
                content={telemetrySchema.description}
                removeFindDomNode
              >
                <Icons.Info size={Size.SMALL}/>
              </Tooltip>
      }
    </>);

  // const _onChange = useCallback((event, checked) => {
  //   setSelected(old => {
  //     const updated = _.xor(old, [telemetrySchema.name]);
  //     return updated;
  //   });
  // }, [telemetrySchema.name]);

  // const selectableActions = useCallback((schema, selected) => {
  //   if (!isSelectable) {
  //     return null;
  //   }
  //   const selectableAction = {
  //     selectableActionId: schema.name,
  //     selectableActionAriaLabelledBy: schema.displayName,
  //     name: schema.name,
  //     variant: 'multiple',
  //     isChecked: _.includes(selected, schema.name),
  //     onChange: (event, checked) => {
  //       setSelected(old => {
  //         const updated = _.xor(old, [schema.name]);
  //         return updated;
  //       });
  //     }
  //   };
  //   return [selectableAction];
  // }, [isSelectable]);
  return (
    <>
      <Card
        isCompact
        isFlat
        isFullHeight
        isRounded
        key={telemetrySchema.name}
      >
        <CardHeader
          // selectableActions={{
          //   selectableActionId: telemetrySchema.name,
          //   name: telemetrySchema.name,
          //   variant: 'multiple',
          //   isChecked: false,
          //   onChange: _onChange
          // }}
          actions={{ actions: headerActions }}
        >
          <CardTitle>
            { telemetrySchema.displayName || telemetrySchema.name }
          </CardTitle>
        </CardHeader>
        <CardBody >
          <Value
            dtdlContent={telemetrySchema}
            value={telemetryValue?.value}
            showUnit={!hideUnit}
            fontWeight={fontWeights.bold}
            fontStyle={fontStyles.normal}
          />
        </CardBody>
        <CardFooter>
          <TimeStamp
            timestamp={telemetryValue?.timestamp}
            fontSize={fontSizes.small}
            fontWeight={fontWeights.normal}
            fontStyle={fontStyles.normal}
          />
        </CardFooter>
      </Card>
      <ChartViewModal isOpen={viewSignal != null} onClose={onCloseChartView} signal={viewSignal}/>
    </>
  );
};

TelemetryCardV2.propTypes = {
  telemetrySchema: PropTypes.shape({
    displayName: PropTypes.string,
    name: PropTypes.string,
    schema: PropTypes.string,
    unit: PropTypes.string,
    componentName: PropTypes.string
  }).isRequired,
  telemetryValue: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]).isRequired,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(DateTime)])
  }),
  assetId: PropTypes.string.isRequired,
  hideUnit: PropTypes.bool,
  hideChart: PropTypes.bool
};

export default TelemetryCardV2;
